import { useSEO } from "../lib/seo";
import { LegalPage, Section, Mail } from "../components/site/LegalPage";

export default function Terms() {
  useSEO({
    title: "Terms & Conditions — Fetcher",
    description:
      "Fetcher terms of service: marketplace disclaimer, 18+ requirement, prohibited items, fees, disputes, rider status, liability and jurisdiction.",
    path: "/terms",
  });

  return (
    <div data-testid="terms-page">
      <LegalPage eyebrow="Legal" title="Terms & Conditions" updated="June 2026">
        <Section title="1. Marketplace disclaimer">
          <p>
            Fetcher is a technology platform that <strong>facilitates</strong> the purchase and delivery of goods from
            independent local shops by independent riders. We do not manufacture, own, sell or warrant any product
            listed or requested through the app. All items are sold by the respective shops.
          </p>
        </Section>

        <Section title="2. Eligibility (18+)">
          <p>
            You must be at least <strong>18 years of age</strong> to create an account and place orders on Fetcher. By
            using the service you confirm that you meet this requirement.
          </p>
        </Section>

        <Section title="3. Prohibited items">
          <p>You may not use Fetcher to request or deliver:</p>
          <ul className="list-disc space-y-2 pl-6">
            <li>Illegal drugs, controlled substances or prescription medicines without valid prescription.</li>
            <li>Alcohol, tobacco or products restricted to minors where prohibited by law.</li>
            <li>Weapons, explosives, hazardous or flammable materials.</li>
            <li>Stolen, counterfeit or otherwise unlawful goods.</li>
          </ul>
        </Section>

        <Section title="4. Fees">
          <p>
            Fetcher charges a <strong>flat ₹30 delivery fee</strong> plus a <strong>10% platform fee</strong> on the item
            value. The actual item price is set by the shop and confirmed by you (via photo) before purchase. There are
            no hidden charges.
          </p>
        </Section>

        <Section title="5. Dispute window">
          <p>
            If something is wrong with your order, you must raise a dispute within <strong>24 hours</strong> of delivery
            by contacting <Mail />. Disputes raised after this window may not be eligible for resolution or refund.
          </p>
        </Section>

        <Section title="6. Riders are independent contractors">
          <p>
            Riders on Fetcher are <strong>independent contractors</strong>, not employees of Fetcher. They set their own
            availability. Fetcher provides the platform that connects riders with customers.
          </p>
        </Section>

        <Section title="7. Limitation of liability">
          <p>
            To the maximum extent permitted by law, Fetcher's liability for any claim arising from the use of the service
            is limited to the total fees paid by you for the order in question. We are not liable for the quality,
            safety or legality of goods supplied by shops.
          </p>
        </Section>

        <Section title="8. Termination">
          <p>
            We may suspend or terminate accounts that violate these terms, engage in fraud, or misuse the platform. You
            may stop using Fetcher at any time.
          </p>
        </Section>

        <Section title="9. Jurisdiction">
          <p>
            These Terms are governed by the laws of India and subject to the exclusive jurisdiction of the courts of
            <strong> Tamil Nadu</strong>. Questions? Email <Mail />.
          </p>
        </Section>
      </LegalPage>
    </div>
  );
}
